import {
  BarChart as RechartsBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { CHART_COLORS, CHART_THEME, chartTooltipStyle, formatChartCurrency } from './chartTheme';

export interface BarSeries {
  key: string;
  label: string;
  color?: string;
}

interface BarChartProps {
  data: Record<string, string | number>[];
  xKey: string;
  series: BarSeries[];
  height?: number;
  stacked?: boolean;
  valueFormatter?: (value: number) => string;
}

function BarChart({
  data,
  xKey,
  series,
  height = 260,
  stacked = false,
  valueFormatter = formatChartCurrency,
}: BarChartProps) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsBarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={CHART_THEME.grid} vertical={false} />
        <XAxis
          dataKey={xKey}
          tick={{ fill: CHART_THEME.axis, fontSize: 11 }}
          axisLine={{ stroke: CHART_THEME.grid }}
          tickLine={false}
        />
        <YAxis
          tick={{ fill: CHART_THEME.axis, fontSize: 11 }}
          axisLine={false}
          tickLine={false}
          tickFormatter={valueFormatter}
          width={56}
        />
        <Tooltip
          contentStyle={chartTooltipStyle}
          formatter={(value: number) => valueFormatter(value)}
        />
        <Legend wrapperStyle={{ fontSize: '12px', color: CHART_THEME.axis }} />
        {series.map((s, i) => (
          <Bar
            key={s.key}
            dataKey={s.key}
            name={s.label}
            fill={s.color ?? CHART_COLORS[i % CHART_COLORS.length]}
            radius={[4, 4, 0, 0]}
            stackId={stacked ? 'stack' : undefined}
            animationDuration={600}
          />
        ))}
      </RechartsBarChart>
    </ResponsiveContainer>
  );
}

export default BarChart;
